import { useAuthStore } from '../store/useAuthStore'
import { useOnlineModeStore } from '../store/useOnlineModeStore'

// Ikona „online režim" se třemi stavy (viz doc/plans/to-fill-data-fetching.md, krok 5).
// Renderuje se JEN když uživatel smí dotahovat (canFill). Klik cykluje off → ask → auto.
// Stav drží useOnlineModeStore (localStorage). SVG dědí barvu přes currentColor.

// path z src/assets/icons/data-update-icon.svg (databázový válec + kruhové šipky)
const ICON_PATH =
  'M16.83,25.39C24.55,28,35.28,29.55,47.2,29.55S69.86,28,77.57,25.39c6.77-2.26,11-5,11-7.68s-4.19-5.41-11-7.67C69.86,7.47,59.13,5.88,47.2,5.88S24.55,7.47,16.83,10c-14.36,4.8-14.75,10.42,0,15.35Zm70.1,31.17a33.09,33.09,0,0,1,23.44,9.71v0a33.12,33.12,0,0,1,0,46.86l0,0a33.12,33.12,0,0,1-46.86,0l0,0a33.12,33.12,0,0,1,0-46.86l0,0a33.06,33.06,0,0,1,23.43-9.71Zm1.88,17.52L86,88.12l-2.8-4.22c-6,2.42-9.42,6.42-9.92,12.56-5-8.66-1.95-16.43,4.33-21l-2.86-4.3,14,2.9Zm-4.49,32.13,2.76-14,2.81,4.22c6-2.42,9.42-6.42,9.92-12.56,5,8.66,2,16.43-4.33,21l2.86,4.3-14-2.9ZM106.7,70a28,28,0,1,0,8.19,19.77A27.84,27.84,0,0,0,106.7,70ZM43.92,91C32.69,90.77,22.55,89.12,15,86.6a37.06,37.06,0,0,1-9-4.26v19.18c.53,2.49,4.59,5,10.89,7.11,7.72,2.58,18.45,4.17,30.37,4.17,1.15,0,2.29,0,3.42,0a43.68,43.68,0,0,0,4.32,5.69q-3.78.22-7.74.22c-12.52,0-23.92-1.71-32.23-4.48-4.38-1.47-14.91-6.27-14.91-12V100.3C.06,74.09,0,43.92,0,17.71,0,12.23,5.72,7.58,15,4.49,23.28,1.71,34.68,0,47.2,0S71.12,1.71,79.43,4.49s13.92,6.92,14.84,11.77a2.93,2.93,0,0,1,.17,1V47.35a42.18,42.18,0,0,0-6.08-.64,2.77,2.77,0,0,0,.17-.93h0V26.62a37,37,0,0,1-9.13,4.32c-8.31,2.77-19.71,4.49-32.23,4.49S23.28,33.71,15,30.94a37.44,37.44,0,0,1-9-4.25V46.34c.53,2.49,4.59,5,10.89,7.11C24.55,56,35.28,57.62,47.2,57.62c4.08,0,8-.19,11.74-.54-.62.53-1.22,1.08-1.8,1.64-.22.18-.42.37-.62.56l0,0,0,0,0,0a43.9,43.9,0,0,0-3.55,4c-1.89.08-3.8.12-5.75.12C34.68,63.49,23.28,61.78,15,59a37.06,37.06,0,0,1-9-4.25V73.93c.53,2.49,4.59,5,10.89,7.11,7.05,2.35,16.61,3.88,27.31,4.13a42.92,42.92,0,0,0-.24,4.55c0,.44,0,.88,0,1.32Z'

const STATES = {
  off:  { color: 'text-gray-400', badge: null,  title: 'Online dotahování vypnuto — zobrazují se jen data z databáze' },
  ask:  { color: 'text-blue-600', badge: '?',   title: 'Online režim: před dotažením se zeptat' },
  auto: { color: 'text-green-600', badge: '⟳',  title: 'Online režim: automaticky dotahovat chybějící data' },
}

export function OnlineModeToggle({ className = '' }) {
  const canFill = useAuthStore((s) => s.canFill)
  const mode = useOnlineModeStore((s) => s.mode)
  const cycle = useOnlineModeStore((s) => s.cycle)

  if (!canFill) return null

  const st = STATES[mode] ?? STATES.ask

  return (
    <button
      type="button"
      onClick={cycle}
      title={st.title}
      className={`relative shrink-0 flex items-center transition-colors ${st.color} hover:opacity-80 ${className}`}
    >
      <svg viewBox="0 0 120.09 122.88" className="w-6 h-6" fill="currentColor" aria-hidden="true">
        <path d={ICON_PATH} />
        {mode === 'off' && (
          <line x1="8" y1="112" x2="112" y2="10" stroke="currentColor" strokeWidth="9" strokeLinecap="round" />
        )}
      </svg>
      {st.badge && (
        <span className="absolute -top-1 -right-1 min-w-[13px] h-[13px] px-[2px] flex items-center justify-center rounded-full bg-white text-[9px] font-bold leading-none border border-current">
          {st.badge}
        </span>
      )}
      <span className="sr-only">Online režim: {mode}</span>
    </button>
  )
}
